import { SingleErrorCodesType } from '../interfaces/errorCodes';

/* obiekt przechowujący kody służące do obsługi akcji i błędów */
export const codes: SingleErrorCodesType = {
  NOT_SUFFICIENT_AUTH_TOKEN: 1003,
  INVALID_TICKET: 1103,
  MISSING_TOKEN: 1208,
  INVALID_TOKEN: 1209,
  EXPIRED_TOKEN: 1210,
  CANCELED_TOKEN: 1211,
  FACTOR_CHANGED_TOKEN: 1212,
  EXPIRED_REFRESH_TOKEN: 1221,
  CANCELED_REFRESH_TOKEN: 1222,
  TEACHER_SESSION_ACTIVE_CANNOT_LOGIN: 1235,
  TEACHER_SESSION_ACTIVE_ACCESS_ERROR: 1236,
  RESOURCE_ACCESS_ERROR: 1326,
  SIGN_MARK_WRONG_IP_RANGE: 1638,
  SIGN_MARK_INVALID_MARK_IMPORTANCE: 1648,
  COPY_FINAL_MARKS_ERROR_ADDING_GRADE_TO_DB: 1649,
  COPY_FINAL_MARKS_ERROR_NO_COMPUTED_GRADE: 1650,
  COPY_FINAL_MARKS_ERROR_GRADE_EXIST_SIGNED_MANUALLY: 1651,
  COPY_FINAL_MARKS_ERROR_NO_STUDENT_FOR_SUBJECT: 1652,
  COPY_FINAL_MARKS_ERROR_NO_GRADE_HAS_BEEN_ADDED: 1653,
  BAD_TOKEN: 1704,
  RESOURCE_NOT_EXIST_ERROR: 1799,
  SUBJECT_CARDS_SAVE_SID_ERROR_NO_EFEKTY_KIERUNKOWE: 1860,
  DATABASE_ERROR_2: 2041,
  MARKS_ERROR_WITH_MESSAGE: 2052,
  SAVE_IN_SID_UPDATE_ERROR_8: 2054,
  SAVE_IN_SID_UPDATE_ERROR_7: 2055,
  SAVE_IN_SID_UPDATE_ERROR_6: 2056,
  SAVE_IN_SID_UPDATE_ERROR_5: 2060,
  SAVE_IN_SID_UPDATE_ERROR_4: 2061,
  SAVE_IN_SID_UPDATE_ERROR_3: 2062,
  SAVE_IN_SID_UPDATE_ERROR_2: 2063,
  SAVE_IN_SID_UPDATE_ERROR_1: 2064,
  ERROR_PROTOCOL_GENERATION_NO_PROTOCOL_FOR_PARAMETERS: 2069,
  DATABASE_ERROR: 2099,
  ERROR_PROTOCOL_GENERATION_NO_SUM_CONTROL: 2074,
  INVALID_SMSCODE: 2207,
  WRONG_EMAIL_CODE: 2235,
  SECOND_FA_SMS_STARTED: 2290,
  SECOND_FA_EMAIL_STARTED: 2293,
  WRONG_SMS_CODE: 2310,
  COPY_FINAL_MARKS_ERROR_FOR_LISTED_STUDENTS: 2501,
  INVALID_REFRESH_TOKEN: 4002,
  REPORT_ALREADY_GENERATED: 5555,
  REPORT_GENERATION_IN_PROGRESS: 5550,
  MAINTENANCE_MODE: 6660,

  //NOWE:

  //do CASa:
  NO_AUTH_TOKEN: 2404,
  NOT_COMPLETE_AUTH_TOKEN: 2405,
  NOT_VALID_AUTH_TOKEN: 2406,
  NO_FACTOR_LIST_IN_HEADER: 2407,
  TOO_LOW_FACTOR_LEVEL: 2408,
  EMPTY_FACTOR_LIST_IN_HEADER: 2409,
  ERROR_NO_AUTHORIZATION: 2224,
  ERROR_WRONG_AUTHORIZATION: 2225,
  ERROR_TOKEN_ERROR: 2039,
  ERROR_TOKEN_USER_MISSING_DB: 2002,
  ERROR_TOKEN_USER_ID_MISSING_DB: 2003,
  ERROR_TOKEN_USER_ID_MIN_DB: 2004,
  ERROR_TOKEN_USER_ID_MAX_DB: 2005,
  ERROR_TOKEN_USER_ID_NOT_NUMBER_DB: 2006,
  ERROR_TOKEN_MISSING_DB: 2016,
  ERROR_TOKEN_INVALID_DB: 2024,
  URL_MALFORMED_DB: 2042,
  ERROR_TOKEN_ERROR_OCENY: 1602,
  ERROR_TOKEN_USER_MISSING_OCENY: 1603,
  ERROR_USER_MISSING_OCENY: 1604,
  ERROR_TOKEN_USER_ID_MISSING_OCENY: 1605,
  ERROR_TOKEN_USER_ID_MIN_OCENY: 1606,
  ERROR_TOKEN_USER_ID_MAX_OCENY: 1607,
  ERROR_TOKEN_USER_ID_NOT_NUMBER_OCENY: 1608,
  URL_MALFORMED_OCENY: 1614,
  ERROR_USER_MISSING_PROTOKOLY: 2519,
  ERROR_TOKEN_USER_ID_MISSING_PROTOKOLY: 2520,
  ERROR_TOKEN_USER_ID_MIN_PROTOKOLY: 2521,
  ERROR_TOKEN_USER_ID_MAX_PROTOKOLY: 2524,
  ERROR_TOKEN_DATA_IS_NULL_PROTOKOLY: 2523,
  ERROR_PARSING_USER_FROM_TOKEN_PROTOKOLY: 2522,
  ERROR_TOKEN_USER_ID_NOT_NUMBER_PROTOKOLY: 2528,
  ERROR_TOKEN_CANNOT_BE_PARSED_PROTOKOLY: 2529,
  URL_MALFORMED_PROTOKOLY: 2503,
  ERROR_TOKEN_MISSING_PRZEDMIOTY: 1702,
  ERROR_PARSING_USER_FROM_TOKEN_PRZEDMIOTY: 1703,
  ERROR_TOKEN_USER_ID_MISSING_PRZEDMIOTY: 1705,
  ERROR_TOKEN_USER_ID_MIN_PRZEDMIOTY: 1706,
  ERROR_TOKEN_USER_ID_MAX_PRZEDMIOTY: 1707,
  ERROR_TOKEN_USER_ID_NOT_NUMBER_PRZEDMIOTY: 1708,
  URL_MALFORMED_PRZEDMIOTY: 1736,
  NO_SMS_API_TOKEN_SMS: 2307,
  URL_MALFORMED_SMS: 2308,
  ERROR_TOKEN_MISSING_STUDENCI: 1402,
  ERROR_PARSING_USER_FROM_TOKEN_STUDENCI: 1403,
  ERROR_TOKEN_USER_MISSING_STUDENCI: 1404,
  ERROR_TOKEN_USER_ID_MISSING_STUDENCI: 1405,
  ERROR_TOKEN_USER_ID_MIN_STUDENCI: 1406,
  ERROR_TOKEN_USER_ID_MAX_STUDENCI: 1407,
  ERROR_TOKEN_USER_ID_NOT_NUMBER_STUDENCI: 1408,
  URL_MALFORMED_STUDENCI: 2308,
  ERROR_TOKEN_USER_MISSING_USER_CONFIG: 1902,
  ERROR_TOKEN_USER_ID_MISSING_USER_CONFIG: 1903,
  ERROR_TOKEN_USER_ID_MIN_USER_CONFIG: 1904,
  ERROR_TOKEN_USER_ID_MAX_USER_CONFIG: 1905,
  ERROR_TOKEN_USER_ID_NOT_NUMBER_USER_CONFIG: 1906,
  ERROR_TOKEN_MISSING_USER_CONFIG: 1916,
  ERROR_TOKEN_INVALID_USER_CONFIG: 1924,
  URL_MALFORMED_USER_CONFIG: 1926,
  TOKEN_USER_MISSING: 1502,
  TOKEN_USER_ID_MISSING: 1503,
  TOKEN_USER_ID_MIN: 1504,
  TOKEN_USER_ID_MAX: 1505,
  TOKEN_USER_ID_NOT_NUMBER: 1506,
  TOKEN_INVALID: 1507,
  WHOAMI_UNKNOWN_TOKEN: 1508,
  URL_MALFORMED_USERS: 1515,
  UNAUTHORIZED_USER_USERS: 1523,
  SMS_CODE_EXPIRED: 2236,

  //Błędny adres url żadania /// przekaż informacje administratorowi
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_1: 2401,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_2: 2410,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_3: 2411,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_4: 2412,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_5: 2413,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_6: 2414,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_7: 2415,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_8: 2416,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_9: 2417,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_ACL_10: 2418,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_1: 2901,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_2: 2902,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_3: 2903,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_4: 2904,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_5: 2905,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_6: 2906,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_7: 2907,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_8: 2908,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_9: 2909,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_10: 2910,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_EMAIL_11: 2911,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_1: 1861,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_2: 1884,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_3: 1885,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_4: 1886,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_5: 1887,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_6: 1888,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_KP_7: 1889,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_1: 2228,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_2: 2229,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_3: 2230,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_4: 2231,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_5: 2232,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_6: 2233,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_7: 2234,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_8: 2236,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_9: 2237,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_10: 2238,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_11: 2239,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_12: 2298,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_MFA_13: 2299,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_1: 2000,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_2: 2001,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_3: 2021,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_4: 2022,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_5: 2023,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_6: 2043,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_7: 2044,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_8: 2047,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_9: 2044,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_DATABASE_10: 2098,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_1: 1600,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_2: 1601,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_3: 1612,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_4: 1613,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_5: 1615,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_6: 1619,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_7: 1631,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_8: 1632,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_9: 1633,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_10: 1634,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_OCENY_11: 1698,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_1: 2500,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_2: 2502,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_3: 2504,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_4: 2509,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_5: 2510,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_6: 2511,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_7: 2516,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_8: 2517,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PROTOKOLY_9: 2518,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_1: 1700,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_2: 1701,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_3: 1709,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_4: 1710,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_5: 1711,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_6: 1712,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_7: 1713,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_8: 1734,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_9: 1735,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_10: 1737,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_PRZEDMIOTY_11: 1741,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_1: 2300,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_2: 2301,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_3: 2306,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_4: 2309,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_5: 2312,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_6: 2313,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_7: 2314,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_8: 2315,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_SMS_9: 2316,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_1: 1400,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_2: 1401,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_3: 1409,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_4: 1410,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_5: 1411,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_6: 1435,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_7: 1435,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_8: 2309,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_STUDENCI_9: 2313,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USER_CONFIG_1: 1900,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USER_CONFIG_2: 1901,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USER_CONFIG_3: 1927,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USER_CONFIG_4: 1931,

  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_1: 1500,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_2: 1501,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_3: 1509,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_4: 1510,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_5: 1511,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_6: 1512,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_7: 1513,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_8: 1514,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_9: 1516,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_10: 1520,
  TYPICAL_ERROR_CODES_ALL_MICROSERVICES_USERS_11: 1521,

  //Karta przedmiotu - Błędne dane
  WRONG_DATA_KP_1: 1826,
  WRONG_DATA_KP_2: 1827,
  WRONG_DATA_KP_3: 1828,
  WRONG_DATA_KP_4: 1829,
  WRONG_DATA_KP_5: 1831,
  WRONG_DATA_KP_6: 1832,
  WRONG_DATA_KP_7: 1833,
  WRONG_DATA_KP_8: 1834,
  WRONG_DATA_KP_9: 1835,
  WRONG_DATA_KP_10: 1836,
  WRONG_DATA_KP_11: 1837,
  WRONG_DATA_KP_12: 1838,
  WRONG_DATA_KP_13: 1839,
  WRONG_DATA_KP_14: 1840,
  WRONG_DATA_KP_15: 1841,
  WRONG_DATA_KP_16: 1842,
  WRONG_DATA_KP_17: 1843,
  WRONG_DATA_KP_18: 1844,
  WRONG_DATA_KP_19: 1845,
  WRONG_DATA_KP_20: 1846,
  WRONG_DATA_KP_21: 1847,
  WRONG_DATA_KP_22: 1848,
  WRONG_DATA_KP_23: 1849,
  WRONG_DATA_KP_24: 1850,
  WRONG_DATA_KP_25: 1851,
  WRONG_DATA_KP_26: 1852,
  WRONG_DATA_KP_27: 1853,
  WRONG_DATA_KP_28: 1854,
  WRONG_DATA_KP_29: 1826,
  WRONG_DATA_KP_30: 1826,
  WRONG_DATA_KP_31: 1826,
  WRONG_DATA_KP_32: 1826,
  WRONG_DATA_KP_33: 1826,
  WRONG_DATA_KP_34: 1826,
  WRONG_DATA_KP_35: 1826,
  WRONG_DATA_KP_36: 1855,
  WRONG_DATA_KP_37: 1856,
  WRONG_DATA_KP_38: 1857,
  WRONG_DATA_KP_39: 1858,
  WRONG_DATA_KP_40: 1859,

  //Database - Błędne dane
  WRONG_DATA_DB_1: 2007,
  WRONG_DATA_DB_2: 2008,
  WRONG_DATA_DB_3: 2009,
  WRONG_DATA_DB_4: 2010,
  WRONG_DATA_DB_5: 2011,
  WRONG_DATA_DB_6: 2012,
  WRONG_DATA_DB_7: 2013,
  WRONG_DATA_DB_8: 2014,
  WRONG_DATA_DB_9: 2015,
  WRONG_DATA_DB_10: 2017,
  WRONG_DATA_DB_11: 2018,
  WRONG_DATA_DB_12: 2019,
  WRONG_DATA_DB_13: 2020,
  WRONG_DATA_DB_14: 2025,
  WRONG_DATA_DB_15: 2026,
  WRONG_DATA_DB_16: 2027,
  WRONG_DATA_DB_17: 2028,
  WRONG_DATA_DB_18: 2029,
  WRONG_DATA_DB_19: 2030,
  WRONG_DATA_DB_20: 2031,
  WRONG_DATA_DB_21: 2032,
  WRONG_DATA_DB_22: 2033,
  WRONG_DATA_DB_23: 2034,
  WRONG_DATA_DB_24: 2035,
  WRONG_DATA_DB_25: 2036,
  WRONG_DATA_DB_26: 2037,
  WRONG_DATA_DB_27: 2038,
  WRONG_DATA_DB_28: 2040,
  WRONG_DATA_DB_29: 2043,
  WRONG_DATA_DB_30: 2048,
  WRONG_DATA_DB_31: 2049,
  WRONG_DATA_DB_32: 2050,
  WRONG_DATA_DB_33: 2051,
  WRONG_DATA_DB_34: 2053,
  WRONG_DATA_DB_35: 2057,
  WRONG_DATA_DB_36: 2058,
  WRONG_DATA_DB_37: 2059,
  WRONG_DATA_DB_38: 2065,
  WRONG_DATA_DB_39: 2066,
  WRONG_DATA_DB_40: 2067,
  WRONG_DATA_DB_41: 2068,
  WRONG_DATA_DB_42: 2070,
  WRONG_DATA_DB_43: 2071,
  WRONG_DATA_DB_44: 2072,
  WRONG_DATA_DB_45: 2073,
  WRONG_DATA_DB_46: 2080,

  //Oceny - błędne dane
  WRONG_DATA_OCENY_1: 1609,
  WRONG_DATA_OCENY_2: 1610,
  WRONG_DATA_OCENY_3: 1611,
  WRONG_DATA_OCENY_4: 1620,
  WRONG_DATA_OCENY_5: 1621,
  WRONG_DATA_OCENY_6: 1622,
  WRONG_DATA_OCENY_7: 1623,
  WRONG_DATA_OCENY_8: 1624,
  WRONG_DATA_OCENY_9: 1625,
  WRONG_DATA_OCENY_10: 1626,
  WRONG_DATA_OCENY_11: 1627,
  WRONG_DATA_OCENY_12: 1628,
  WRONG_DATA_OCENY_13: 1629,
  WRONG_DATA_OCENY_14: 1630,
  WRONG_DATA_OCENY_15: 1635,
  WRONG_DATA_OCENY_16: 1636,
  WRONG_DATA_OCENY_17: 1637,
  WRONG_DATA_OCENY_18: 1639,
  WRONG_DATA_OCENY_19: 1640,
  WRONG_DATA_OCENY_20: 1641,
  WRONG_DATA_OCENY_21: 1642,
  WRONG_DATA_OCENY_22: 1643,
  WRONG_DATA_OCENY_23: 1644,
  WRONG_DATA_OCENY_24: 1645,
  WRONG_DATA_OCENY_25: 1646,
  WRONG_DATA_OCENY_26: 1647,

  //Protokoły - błędne dane
  WRONG_DATA_PROTOKOLY_1: 2512,
  WRONG_DATA_PROTOKOLY_2: 2513,
  WRONG_DATA_PROTOKOLY_3: 2514,
  WRONG_DATA_PROTOKOLY_4: 2515,
  WRONG_DATA_PROTOKOLY_5: 2533,
  WRONG_DATA_PROTOKOLY_6: 2534,
  WRONG_DATA_PROTOKOLY_7: 2535,
  WRONG_DATA_PROTOKOLY_8: 2536,
  WRONG_DATA_PROTOKOLY_9: 2537,
  WRONG_DATA_PROTOKOLY_10: 2538,
  WRONG_DATA_PROTOKOLY_11: 2539,
  WRONG_DATA_PROTOKOLY_12: 2540,
  WRONG_DATA_PROTOKOLY_13: 2541,
  WRONG_DATA_PROTOKOLY_14: 2543,
  WRONG_DATA_PROTOKOLY_15: 2544,
  WRONG_DATA_PROTOKOLY_16: 2548,

  //Przedmioty - błędne dane
  WRONG_DATA_PRZEDMIOTY_1: 1714,
  WRONG_DATA_PRZEDMIOTY_2: 1715,
  WRONG_DATA_PRZEDMIOTY_3: 1716,
  WRONG_DATA_PRZEDMIOTY_4: 1717,
  WRONG_DATA_PRZEDMIOTY_5: 1718,
  WRONG_DATA_PRZEDMIOTY_6: 1719,
  WRONG_DATA_PRZEDMIOTY_7: 1720,
  WRONG_DATA_PRZEDMIOTY_8: 1721,
  WRONG_DATA_PRZEDMIOTY_9: 1722,
  WRONG_DATA_PRZEDMIOTY_10: 1723,
  WRONG_DATA_PRZEDMIOTY_11: 1724,
  WRONG_DATA_PRZEDMIOTY_12: 1725,
  WRONG_DATA_PRZEDMIOTY_13: 1726,
  WRONG_DATA_PRZEDMIOTY_14: 1727,
  WRONG_DATA_PRZEDMIOTY_15: 1732,
  WRONG_DATA_PRZEDMIOTY_16: 1733,
  WRONG_DATA_PRZEDMIOTY_17: 1734,

  //SMS - błędne dane
  WRONG_DATA_SMS_1: 2302,
  WRONG_DATA_SMS_2: 2303,
  WRONG_DATA_SMS_3: 2304,
  WRONG_DATA_SMS_4: 2305,

  //Studenci - błędne dane
  WRONG_DATA_STUDENCI_1: 1412,
  WRONG_DATA_STUDENCI_2: 1413,
  WRONG_DATA_STUDENCI_3: 1414,
  WRONG_DATA_STUDENCI_4: 1415,
  WRONG_DATA_STUDENCI_5: 1416,
  WRONG_DATA_STUDENCI_6: 1417,
  WRONG_DATA_STUDENCI_7: 1418,
  WRONG_DATA_STUDENCI_8: 1419,
  WRONG_DATA_STUDENCI_9: 2420,
  WRONG_DATA_STUDENCI_10: 2421,
  WRONG_DATA_STUDENCI_11: 1422,
  WRONG_DATA_STUDENCI_12: 1423,
  WRONG_DATA_STUDENCI_13: 1424,
  WRONG_DATA_STUDENCI_14: 1425,
  WRONG_DATA_STUDENCI_15: 1426,
  WRONG_DATA_STUDENCI_16: 1427,
  WRONG_DATA_STUDENCI_17: 1428,
  WRONG_DATA_STUDENCI_18: 1429,
  WRONG_DATA_STUDENCI_19: 2430,
  WRONG_DATA_STUDENCI_20: 2431,
  WRONG_DATA_STUDENCI_21: 2432,
  WRONG_DATA_STUDENCI_22: 2433,
  WRONG_DATA_STUDENCI_23: 2434,

  //User config - błędne dane
  WRONG_DATA_USER_CONFIG_1: 1907,
  WRONG_DATA_USER_CONFIG_2: 1908,
  WRONG_DATA_USER_CONFIG_3: 1909,
  WRONG_DATA_USER_CONFIG_4: 1910,
  WRONG_DATA_USER_CONFIG_5: 1911,
  WRONG_DATA_USER_CONFIG_6: 1912,
  WRONG_DATA_USER_CONFIG_7: 1913,
  WRONG_DATA_USER_CONFIG_8: 1914,
  WRONG_DATA_USER_CONFIG_9: 1915,
  WRONG_DATA_USER_CONFIG_10: 1917,
  WRONG_DATA_USER_CONFIG_11: 1918,
  WRONG_DATA_USER_CONFIG_12: 1919,
  WRONG_DATA_USER_CONFIG_13: 1920,
  WRONG_DATA_USER_CONFIG_14: 1921,
  WRONG_DATA_USER_CONFIG_15: 1922,
  WRONG_DATA_USER_CONFIG_16: 1923,
  WRONG_DATA_USER_CONFIG_17: 1925,

  //Protokoly - blad bazy danych
  DATABASE_ERROR_PROTOKOLY_1: 2530,
  DATABASE_ERROR_PROTOKOLY_2: 2531,
  DATABASE_ERROR_PROTOKOLY_3: 2046,
  DATABASE_ERROR_PROTOKOLY_4: 2530,
  DATABASE_ERROR_PROTOKOLY_5: 2075,
  DATABASE_ERROR_PROTOKOLY_6: 2079,

  //Protokoly - blad generowania
  GENERATE_ERROR_PROTOKOLY_1: 2551,
  GENERATE_ERROR_PROTOKOLY_2: 2552,
  GENERATE_ERROR_PROTOKOLY_3: 2553,
  GENERATE_ERROR_PROTOKOLY_4: 2045,

  //Protokoly - inne
  ERROR_PROTOCOL_GENERATION_IS_NOT_AVAILABLE: 2542,
  ERROR_PROTOCOL_GENERATION_NO_STUDENTS_WITH_SIGNED_MARKS: 2545,
  ERROR_PROTOCOL_GENERATION_USER_NOT_AUTHORIZED: 2546,
  ERROR_PROTOCOL_GENERATION_OUT_OF_DATE: 2547,
  ERROR_PROTOCOL_GENERATION_HAS_NOT_FINISHED: 2549,
  ERROR_PROTOCOL_GENERATION_IS_NOT_AVAILABLE_NEW: 2554,
};
